<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container">
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar  style="background: #01579b;" class="topbar telative">
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div class="navbar-header">
            <a class="navbar-brand" href="./">
                <!-- Logo icon -->
                <!-- <b> -->
                    <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                    <!-- Dark Logo icon -->
                    <!-- <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo"> -->
                    <!-- Light Logo icon -->
                    <!-- <img src="assets/images/logo-light-icon.png" alt="homepage" class="light-logo"> -->
                <!-- </b> -->
                <!--End Logo icon -->
                <!-- Logo text -->
                <span fxShow="false" fxShow.gt-xs style='color: white;'>
                 <!-- dark Logo text -->
                 <img src="assets/images/logogen.jpg" width="22px" height="65px" alt="homepage" class="dark-logo">
                 <!-- Light Logo text -->
                 <!-- <img src="assets/images/logogen.jpg" width="220px" height="65px" class="profile-pic2" alt="homepage"> -->
                 S/N: {{ sessiondetail==null? sessionNumber: sessiondetail.sessionCount}}
                </span> </a>
        </div>
        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->

        <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed">
            <mat-icon>menu</mat-icon>
        </button>
        <span fxFlex></span>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <app-header></app-header>
    </mat-toolbar>
    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <!-- <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" (mouseenter)="increase()" (mouseleave)="decrease()" [ngStyle]="{ 'width.em': sidenavWidth }" fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches"> -->
          <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'"  fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches">
                <app-sidebar></app-sidebar>
        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="page-wrapper">

                <div class="page-content">

                        <!-- <router-outlet><app-spinner></app-spinner></router-outlet> -->
                        <!-- <ng-http-loader [backdrop]="false" [debounceDelay]="100" [minDuration]="300" [opacity]=".6" [extraDuration]="300" [backdropBackgroundColor]="'#777777'" [backgroundColor]="'#ff0000'" spinner="sk-wave"></ng-http-loader> -->
                        <router-outlet>
                          <!-- <ng-http-loader [backdrop]="false" [debounceDelay]="100" [minDuration]="100" [opacity]=".6" [extraDuration]="50" [backdropBackgroundColor]="'#777777'" [backgroundColor]="'#ff0000'" spinner="sk-wave"></ng-http-loader> -->
                        </router-outlet>

                </div>

        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</div>
